import React from "react";
import PropTypes from "prop-types";
import StylePropType from "react-style-proptype";
import Radium from "radium";
import flow from "lodash.flow";
import { DragSource, DropTarget } from "react-dnd";
import ListItem from "../../components/SelectableListItem";
import { source, sourceCollect, target, targetCollect } from "../../dnd/widget";
import Types from "../../dnd/types";

// eslint-disable-next-line react/prefer-stateless-function
class DraggableListItem extends React.Component {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.onClick(this.props, this);
  }

  render() {
    const {
      isDragging,
      connectDragSource,
      connectDropTarget,
      style,
      ...listItemProps
    } = this.props;

    const opacity = isDragging ? 0.2 : 1;
    const selectedItemStyle = style.selected || {};

    return connectDragSource(
      connectDropTarget(
        <div style={[{ opacity }, this.props.style]} role="presentation">
          <ListItem
            {...listItemProps}
            selectedStyle={selectedItemStyle}
            onClick={this.onClick}
          >
            {this.props.text}
          </ListItem>
        </div>
      )
    );
  }
}

DraggableListItem.propTypes = {
  isDragging: PropTypes.bool,
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  text: PropTypes.string,
  style: StylePropType,
  onClick: PropTypes.func
};

DraggableListItem.defaultProps = {
  isDragging: false,
  text: "",
  style: {},
  onClick: () => {}
};

export default flow([
  DragSource(Types.WIDGET, source, sourceCollect),
  DropTarget(Types.WIDGET, target, targetCollect)
])(Radium(DraggableListItem));



// WEBPACK FOOTER //
// ./src/components/DraggableListItem/index.js